import * as React from "react";

// hook for keeping horizontal scrolling of table-body and
// header in sync
function useScroll() {
  const headerRef = React.useRef<HTMLDivElement>(null);

  const lastScrollLeft = React.useRef(0);
  const animationFrameIdRef = React.useRef<any>(null);

  const handleScroll = React.useCallback(evt => {
    if (evt.target.scrollLeft !== lastScrollLeft.current) {
      lastScrollLeft.current = evt.target.scrollLeft;
      if (headerRef.current) {
        if (animationFrameIdRef.current) {
          window.cancelAnimationFrame(animationFrameIdRef.current);
        }
        animationFrameIdRef.current = window.requestAnimationFrame(() => {
          headerRef.current!.scrollLeft = lastScrollLeft.current;
        });
      }
    }
  }, []);

  const handleRegisterOuterRef = (element: HTMLDivElement) => {
    if (element) {
      element.onscroll = handleScroll;
    }
  };

  return {
    headerRef,
    outerGridRef: handleRegisterOuterRef
  };
}

export default useScroll;
